import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import { COMPANY, COMPANY_ADDRESS } from "../core/constants";

const Privacy = () => {
  return (
    <>
      <Header />
      <section className="relative flex w-full bg-purple-800">
        <div className="container pt-[170px] pb-16 mx-auto ">
          <h1 class="title-font px-8 text-1xl md:text-2xl lg:text-3xl font-medium text-white leading-tight line-height-tight drop-shadow-lg">
            Privacy Policy
          </h1>
        </div>
      </section>

      <section className="text-gray-600 body-font bg-gray-100 pt-4 pb-1">
        <div class="container px-5 mt-4 mb-8 mx-auto flex flex-wrap">
          <a
            href="/terms"
            className="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium bg-purple-800 text-white hover:cursor-pointer"
          >
            👈 See all our terms &amp; conditions
          </a>
        </div>
      </section>

      <div class="container px-5 py-12 mx-auto flex flex-wrap text-gray-600 body-font">
        <div className="text-base">
          <p className="mb-4">
            This privacy notice tells you what to expect us to do with your
            personal information.
          </p>
          <ul className="ml-8 list-disc">
            <li>
              <a href="#contact-details" className="text-indigo-500">
                Contact details
              </a>
            </li>
            <li>
              <a href="#why" className="text-indigo-500">
                What information we collect, use, and why
              </a>
            </li>
            <li>
              <a href="#lawful-bases" className="text-indigo-500">
                Lawful bases and data protection rights
              </a>
            </li>
            <li>
              <a href="#where" className="text-indigo-500">
                Where we get personal information from
              </a>
            </li>
            <li>
              <a href="#how-long" className="text-indigo-500">
                How long we keep information
              </a>
            </li>
            <li>
              <a href="#who-we-share-with" className="text-indigo-500">
                Who we share information with
              </a>
            </li>
            <li>
              <a href="#complain" className="text-indigo-500">
                How to complain
              </a>
            </li>
          </ul>
          <div id="contact-details">
            <h3 className="font-abeezee text-2xl font-bold mt-8">
              Contact details
            </h3>
          </div>
          <p className="mb-4">
            <span className="block">
              {COMPANY}, {COMPANY_ADDRESS}
            </span>

            <a href="mailto:dpo@zeropa.co.uk" className="text-indigo-500">
              dpo[at]zeropa.co.uk
            </a>
          </p>
          <div id="why">
            <h3 className="font-abeezee text-2xl font-bold mt-8">
              What information we collect, use, and why
            </h3>
          </div>
          <p className="mb-4">
            We collect or use the following personal information for the
            <span className="font-bold pl-1">
              operation of client or customer accounts
            </span>
            :
            <ul className="mt-2 ml-8 list-disc">
              <li>Names and contact details</li>
              <li>Addresses</li>
              <li>Purchase or service history</li>
              <li>Account information, including registration details</li>
              <li>Marketing preferences</li>
              <li>
                Technical data, including information about browser and
                operating systems
              </li>
            </ul>
          </p>
          <p className="mb-4">
            We collect or use the following personal information to{" "}
            <span className="font-bold pl-1">
              comply with legal requirements
            </span>
            :
            <ul className="mt-2 ml-8 list-disc">
              <li>Name</li>
              <li>Contact information</li>
              <li>Identification documents</li>
              <li>Client account information</li>
              <li>
                Any other personal information required to comply with legal
                obligations
              </li>
            </ul>
          </p>
          <p className="mb-4">
            We collect or use the following personal information for{" "}
            <span className="font-bold pl-1">
              dealing with queries, complaints or claims
            </span>
            :
            <ul className="mt-2 ml-8 list-disc">
              <li>Names and contact details</li>
              <li>Address</li>
              <li>Account information</li>
              <li>Purchase or service history</li>

              <li>Relevant information from previous investigations</li>
              <li>Customer or client accounts and records</li>
              <li>Financial transaction information</li>
            </ul>
          </p>
          <div id="lawful-bases">
            <h3 className="font-abeezee text-2xl font-bold mt-8">
              Lawful bases and data protection rights
            </h3>
          </div>
          <p className="mb-4">
            Under UK data protection law, we must have a “lawful basis” for
            collecting and using your personal information. There is a list of
            possible lawful bases in the UK GDPR. You can find out more about
            lawful bases on the ICO&apos;s website.
          </p>
          <p className="mb-4">
            Which lawful basis we rely on may affect your data protection rights
            which are in brief set out below. You can find out more about your
            data protection rights and the exemptions which may apply on the
            ICO&apos;s website:
          </p>

          <ul className="mt-2 ml-8 list-disc">
            <li>
              <span className="font-bold">Your right of access</span> - You have
              the right to ask us for copies of your personal information. You
              can request other information such as details about where we get
              personal information from and who we share personal information
              with. There are some exemptions which means you may not receive
              all the information you ask for. You can
              <a
                className="ml-1 text-indigo-500"
                target="_blank"
                rel="noopener noreferrer"
                href="https://ico.org.uk/for-organisations/advice-for-small-organisations/create-your-own-privacy-notice/your-data-protection-rights/#roa"
              >
                read more about this right here.
              </a>
            </li>
            <li>
              <span className="font-bold">Your right to rectification</span> -
              You have the right to ask us to correct or delete personal
              information you think is inaccurate or incomplete. You can{" "}
              <a
                className="ml-1 text-indigo-500"
                target="_blank"
                rel="noopener noreferrer"
                href="https://ico.org.uk/for-organisations/advice-for-small-organisations/create-your-own-privacy-notice/your-data-protection-rights/#rtr"
              >
                read more about this right here.
              </a>
            </li>
            <li>
              <span className="font-bold">Your right to erasure</span> - You
              have the right to ask us to delete your personal information. You
              can{" "}
              <a
                className="ml-1 text-indigo-500"
                target="_blank"
                rel="noopener noreferrer"
                href="https://ico.org.uk/for-organisations/advice-for-small-organisations/create-your-own-privacy-notice/your-data-protection-rights/#rte"
              >
                read more about this right here.
              </a>
            </li>
            <li>
              <span className="font-bold">
                Your right to restriction of processing
              </span>{" "}
              - You have the right to ask us to limit how we can use your
              personal information. You can{" "}
              <a
                className="ml-1 text-indigo-500"
                target="_blank"
                rel="noopener noreferrer"
                href="https://ico.org.uk/for-organisations/advice-for-small-organisations/create-your-own-privacy-notice/your-data-protection-rights/#rtrop"
              >
                read more about this right here.
              </a>
            </li>
            <li>
              <span className="font-bold">
                Your right to object to processing
              </span>{" "}
              - You have the right to object to the processing of your personal
              data. You can{" "}
              <a
                className="ml-1 text-indigo-500"
                target="_blank"
                rel="noopener noreferrer"
                href="https://ico.org.uk/for-organisations/advice-for-small-organisations/create-your-own-privacy-notice/your-data-protection-rights/#rto"
              >
                read more about this right here.
              </a>
            </li>
            <li>
              <span className="font-bold">Your right to data portability</span>{" "}
              - You have the right to ask that we transfer the personal
              information you gave us to another organisation, or to you. You
              can{" "}
              <a
                className="ml-1 text-indigo-500"
                target="_blank"
                rel="noopener noreferrer"
                href="https://ico.org.uk/for-organisations/advice-for-small-organisations/create-your-own-privacy-notice/your-data-protection-rights/#rtdp"
              >
                read more about this right here.
              </a>
            </li>
            <li>
              <span className="font-bold">Your right to withdraw consent</span>{" "}
              - When we use consent as our lawful basis you have the right to
              withdraw your consent at any time. You can{" "}
              <a
                className="ml-1 text-indigo-500"
                target="_blank"
                rel="noopener noreferrer"
                href="https://ico.org.uk/for-organisations/advice-for-small-organisations/create-your-own-privacy-notice/your-data-protection-rights/#rtwc"
              >
                read more about this right here.
              </a>
            </li>
          </ul>

          <p className="mb-4 mt-4">
            If you make a request, we must respond to you without undue delay
            and in any event within one month. To make a data protection rights
            request, please contact us using the contact details at the top of
            this privacy notice.
          </p>

          <h4 className="font-abeezee text-1xl font-bold mt-4">
            Our lawful bases for the collection and use of your data
          </h4>

          <p className="mb-4">
            Our lawful bases for collecting or using personal information for
            the operation of client or customer accounts are:
            <ol className="mt-2 ml-8 list-disc">
              {/* <li>
                <span className="font-bold">Consent</span> - we have permission
                from you after we gave you all the relevant information. All of
                your data protection rights may apply, except the right to
                object. To be clear, you do have the right to withdraw your
                consent at any time.
              </li> */}
              <li>
                <span className="font-bold">Contract</span> - we have to collect
                or use the information so we can enter into or carry out a
                contract with you. All of your data protection rights may apply
                except the right to object.
              </li>
              <li>
                <span className="font-bold">Legal obligation</span> - we have to
                collect or use your information so we can comply with the law.
                All of your data protection rights may apply, except the right
                to erasure, the right to object and the right to data
                portability.
              </li>
            </ol>
          </p>
          <p className="mb-4">
            Our lawful bases for collecting or using personal information to
            comply with legal requirements:
            <ol className="mt-2 ml-8 list-disc">
              {/* <li>
                <span className="font-bold">Consent</span> - we have permission
                from you after we gave you all the relevant information. All of
                your data protection rights may apply, except the right to
                object. To be clear, you do have the right to withdraw your
                consent at any time.
              </li> */}
              <li>
                <span className="font-bold">Contract</span> - we have to collect
                or use the information so we can enter into or carry out a
                contract with you. All of your data protection rights may apply
                except the right to object.
              </li>
              <li>
                <span className="font-bold">Legal obligation</span> - we have to
                collect or use your information so we can comply with the law.
                All of your data protection rights may apply, except the right
                to erasure, the right to object and the right to data
                portability.
              </li>
            </ol>
          </p>
          <p className="mb-4">
            Our lawful bases for collecting or using personal information for
            dealing with queries, complaints or claims are:
            <ol className="mt-2 ml-8 list-disc">
              <li>
                <span className="font-bold">Consent</span> - we have permission
                from you after we gave you all the relevant information. All of
                your data protection rights may apply, except the right to
                object. To be clear, you do have the right to withdraw your
                consent at any time.
              </li>
              <li>
                <span className="font-bold">Contract</span> - we have to collect
                or use the information so we can enter into or carry out a
                contract with you. All of your data protection rights may apply
                except the right to object.
              </li>
              <li>
                <span className="font-bold">Legal obligation</span> - we have to
                collect or use your information so we can comply with the law.
                All of your data protection rights may apply, except the right
                to erasure, the right to object and the right to data
                portability.
              </li>
            </ol>
          </p>

          <div id="where">
            <h3 className="font-abeezee text-2xl font-bold mt-8">
              Where we get personal information from
            </h3>
          </div>

          <p className="mb-4">Directly from you.</p>

          <div id="who-we-share-with">
            <h3 className="font-abeezee text-2xl font-bold mt-8">
              How long we keep information
            </h3>
          </div>

          <p className="mb-4">
            We keep your information as shown in the table below:
          </p>

          <div className="text-sm">
            <table className="table-auto md:table-fixed w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th className="py-4" scope="col">
                    <span className="font-bold">Data Category</span>
                  </th>
                  <th scope="col">
                    <span className="font-bold">Purpose</span>
                  </th>
                  <th scope="col">
                    <span className="font-bold">Legal Basis</span>
                  </th>
                  <th scope="col">
                    <span className="font-bold">Retention Period</span>
                  </th>
                  <th scope="col">
                    <span className="font-bold">Reason for Retention</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
                  <th scope="row" className="py-4 vertical-align-top">
                    <span className="font-bold">
                      Customer account information
                    </span>
                  </th>
                  <td>Contract administration, compliance</td>
                  <td>Contract, Legal obligation</td>
                  <td>6 years after account closure</td>
                  <td>Limitation Act 1980; FCA SYSC retention requirements;</td>
                </tr>
                <tr className="border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
                  <th scope="row" className="py-4">
                    <span className="font-bold">Transaction data</span>
                  </th>
                  <td>Regulatory compliance, fraud prevention</td>
                  <td>Legal obligation, Legitimate interest</td>
                  <td>6 years from date of transaction</td>
                  <td>
                    FCA & HMRC regulations (including anti-money laundering)
                  </td>
                </tr>
                <tr className="border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
                  <th scope="row" className="py-4">
                    <span className="font-bold">
                      KYC &amp; AML documentation
                    </span>
                  </th>
                  <td>Anti-money laundering (AML) checks</td>
                  <td>Legal obligation</td>
                  <td>5 years after end of customer relationship</td>
                  <td>Money Laundering Regulations 2017</td>
                </tr>
                <tr className="border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
                  <th scope="row" className="py-4">
                    <span className="font-bold">Marketing preferences</span>
                  </th>
                  <td>Customer engagement</td>
                  <td>Consent</td>
                  <td>Until consent withdrawn or 2 years</td>
                  <td>Regular review of consent</td>
                </tr>
                <tr className="border-b dark:bg-gray-800 dark:border-gray-700 border-gray-200">
                  <th scope="row" className="py-4">
                    <span className="font-bold">
                      Audit logs &amp; system access records
                    </span>
                  </th>
                  <td>Security, system monitoring</td>
                  <td>Legitimate interest</td>
                  <td>1 year</td>
                  <td>Cybersecurity best practices, risk management</td>
                </tr>
              </tbody>
            </table>

            <p className="mt-4">
              We review our retention periods annually. Data may be anonymised
              for analytical or statistical purposes beyond retention limits.
              Secure deletion and disposal polices are in place. Retention
              schedules are documented and accessible for audits.
            </p>
          </div>

          <div id="how-long">
            <h3 className="font-abeezee text-2xl font-bold mt-8">
              Who we share information with
            </h3>
          </div>

          <p className="mb-4">Others we share personal information with:</p>

          <ul className="space-y-1 text-gray-500 list-disc list-inside dark:text-gray-400">
            <li>Other financial or fraud investigation authorities;</li>
            <li>Regulatory authorities;</li>
            <li>
              Organisations we're legally obliged to share personal information
              with.
            </li>
            <li>
              We share anonymised analytical and statistical information with
              Google &amp; Salesforce for the purposes of systems monitoring.
            </li>
          </ul>

          <div id="complain">
            <h3 className="font-abeezee text-2xl font-bold mt-8">
              How to complain
            </h3>
          </div>

          <p className="mb-4">
            If you have any concerns about our use of your personal data, you
            can make a complaint to us using the contact details at the top of
            this privacy notice.
          </p>

          <p className="mb-4">
            If you remain unhappy with how we&apos;ve used your data after
            raising a complaint with us, you can also complain to the ICO.
          </p>

          <p className="mb-4">The ICO&apos;s address:</p>

          <div className="mt-4 bg-gray-50 p-2 rounded-sm">
            <div>
              <span>
                Information Commissioner&apos;s Office
                <br />
                Wycliffe House
                <br />
                Water Lane
                <br />
                Wilmslow
                <br />
                Cheshire
                <br />
                SK9 5AF
                <br />
              </span>
            </div>
          </div>

          <div className="mt-4 bg-gray-50 p-2 rounded-sm">
            <div>
              <span className="font-bold">Helpline number</span>
              <span className="ml-4">0303 123 1113</span>
            </div>
          </div>

          <div className="mt-4 bg-gray-50 p-2 rounded-sm">
            <div>
              <span className="font-bold">Website</span>
              <span className="ml-4">
                <a
                  className="ml-1 text-indigo-500"
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.ico.org.uk/make-a-complaint"
                >
                  https://www.ico.org.uk/make-a-complaint
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Privacy;
